export default {
    method:{
        formatCurrency(price) {
            const formatter = new Intl.NumberFormat('vi-VN', {
                style: 'currency',
                currency: 'VND',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
            return formatter.format(parseInt(price));
        }
    }
}